import { Injectable } from '@angular/core';

import _ from 'lodash';

declare var $: any, myapp_config: any, backup_myapp_config: any, initApp: any, layouts: any;


const CONFIG =  {
  navAnchor: '#js-primary-nav',
  navHooks: '#js-nav-menu',
  navFilterInput: '#nav_filter_input',
  // appDateHook: '.js-get-date',
  // mythemeColorProfileID: '#js-color-profile',
}

@Injectable({
  providedIn: 'root',
})
export class SmartAdminConfigService {
  constructor() {

    // Khởi tạo giá trị null để xử lý với bối cảnh: Không cần truy vấn DOM nếu đã có dữ liệu rồi.
    myapp_config['navAnchor'] = null;
    myapp_config['navHooks'] = null;
    myapp_config['navFilterInput'] = null;
    // myapp_config['appDateHook'] = null;
    // myapp_config['mythemeColorProfileID'] = null;

    // Lưu config lại
    this.backupConfig();
  }

  //#region public functions

  /**
   * 1. Hàm kích hoạt Js cho app. Chứa các setting cần thiết cho app
   */
  activeApp = () => {
    const newConfig = {
      root_: $(myapp_config['root_']), // used for core app reference
      root_logo: $(myapp_config['root_logo']), // used for core app reference
    };

    Object.assign(myapp_config, newConfig);

    /* =========   Do not change order   ==========*/
    /**
     * detect desktop or mobile
     **/
    initApp.addDeviceType();

    /**
     * detect Webkit Browser
     **/
    initApp.detectBrowserType();

    /**
     * check for mobile view width and add class .mobile-view-activated
     **/
    initApp.mobileCheckActivation();

    this.backupConfig();
  };

  /**
   * 2. Hàm kích hoạt Js cho left panel
   */
  activeLeftPanel = () => {

    const newConfig = {
      navHooks: $(CONFIG['navHooks']),
      navFilterInput: $(CONFIG['navFilterInput']),
      navAnchor: $(CONFIG['navAnchor']),
    };
    Object.assign(myapp_config, _.cloneDeep(newConfig));

    /**
     * b. build navigation
     **/
    initApp.buildNavigation(myapp_config.navHooks);

    /**
     * c. initialize nav filter
     **/
    initApp.listFilter(
      myapp_config.navHooks,
      myapp_config.navFilterInput,
      myapp_config.navAnchor
    );

  };

  /**
   * 3.a Hàm kích hoạt Js cho chỉ dành cho layout blank
   */
  activeBlankLayout  = () => {

    this.activeBaseLayout();

    initApp.tooltips();
    initApp.popovers();

    // fix navigation on when init app
    this.boxed('off');
    this.horizontalNavigation('off');
  };

  /**
   * 3.b Hàm kích hoạt Js cho chỉ dành cho layout member
   */
  activeMemberLayout = () => {

    this.activeBaseLayout();

    initApp.tooltips();
    initApp.popovers();

    // fix navigation on when init app
    layouts.fixedNavigation('on');
    layouts.boxed('off');
    layouts.horizontalNavigation('off');
  };

  /**
   * 4. Hàm reset config về trạng thái ban đầu
   * @description Mục đích: tránh việc cấu hình bị thay đổi khi chuyển layout
   */
  resetConfig = () => {
    const config = _.cloneDeep(backup_myapp_config);
    Object.assign(myapp_config, config);
  }

  //#endregion

  //#region private functions

  private backupConfig = () => {
    const config = _.cloneDeep(myapp_config);
    Object.assign(backup_myapp_config, config);
  }

  private cleanBackground = (mode: 'on' | 'off') => {
    layouts.cleanBackground(mode);
  };

  private boxed = (mode: 'on' | 'off') => {
    layouts.boxed(mode);
  };

  private horizontalNavigation = (mode: 'on' | 'off') => {
    layouts.horizontalNavigation(mode);
  };

  private activeBaseLayout = () => {

    const newConfig = {
      /**
       * Tái sử dụng config từ "2. Hàm kích hoạt Js cho left panel", nếu chưa thì khai báo mới
       * Các biến này được dùng ở  "d. run DOM misc functions"
       */
      navHooks: myapp_config['navHooks'] || $(myapp_config['navHooks']),
      navFilterInput: myapp_config['navFilterInput'] || $(myapp_config['navFilterInput']),
      navAnchor: myapp_config['navAnchor'] || $(myapp_config['navAnchor']),
      // --------------
      appDateHook: $(myapp_config['appDateHook']),
      mythemeColorProfileID: $(myapp_config['mythemeColorProfileID']),
    };

    Object.assign(myapp_config, _.cloneDeep(newConfig));

    /* =========   Do not change order   ==========*/

    initApp.blendColor();

    /**
     * d. run DOM misc functions
     **/
    initApp.domReadyMisc();

    /**
     * e. run app forms class detectors [parentClass,focusClass,disabledClass]
     **/
    initApp.appForms('.input-group', 'has-length', 'has-disabled');


    /**
     * Logic này xử lý tránh việc chạy lặp lại nhiều lần khi component được khởi tạo nhiều lần
     * Vì: method bên dưới có logic listener
     */

    if (!initApp?.['actionToggleInitialized']) {
      initApp.readyActionToggle();
      initApp['actionToggleInitialized'] = true;
    }

  };
  //#endregion
}
